// Per-user preferences helper. Reads the bag once from a meta tag
// the layout exposes, and writes back via PATCH /api/preferences so
// prefs follow the user across devices / browsers / incognito tabs.
//
// localStorage stays the fast-path for editor / wizard controllers
// (instant reads, no fetch), but every write that touches a known
// pref key should also call setUserPref so the server is kept in
// sync. Network blips are swallowed — the next successful patch
// catches up.

const META_NAME = "user-preferences"
let _cache = null

function readMeta() {
  if (_cache) return _cache
  try {
    const el = document.querySelector(`meta[name="${META_NAME}"]`)
    if (!el) return (_cache = {})
    return (_cache = JSON.parse(el.content || "{}"))
  } catch (_) { return (_cache = {}) }
}

export function getUserPref(key, fallback = null) {
  const p = readMeta()
  return p[key] != null ? p[key] : fallback
}

export async function setUserPref(key, value) {
  _cache = { ...readMeta(), [key]: value }
  const token = document.querySelector('meta[name="csrf-token"]')?.content
  try {
    await fetch("/api/preferences", {
      method: "PATCH",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        ...(token ? { "X-CSRF-Token": token } : {})
      },
      body: JSON.stringify({ preferences: { [key]: value } })
    })
  } catch (_) {
    // Swallow — localStorage already has the new value and the
    // server-side store will catch up on the next successful patch.
  }
}
